import PropTypes from 'prop-types';
import { useLabel } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './Alert.module.scss';

const Alert = ({ title, children, variant, ...props }) => {
    const { labelProps, fieldProps } = useLabel({
        ...props,
        label: title
    });

    return (
        <div
            className={['govuk-notification-banner', styles[variant], props.className].join(' ')}
            role="alert"
            {...fieldProps}
            data-testid={props['data-testid'] ? props['data-testid'] : null}
        >
            <div
                className="govuk-notification-banner__header"
            >
                <h2
                    className="govuk-notification-banner__title"
                    {...labelProps}
                >
                    {title}
                </h2>
            </div>
            <div className={['govuk-notification-banner__content', styles.content].join(' ')}>
                {props.withIcon && <div className={styles.iconContainer}><span className={['govuk-warning-text__icon', styles.icon].join(' ')} aria-hidden="true">!</span></div>}
                <div>{children}</div>
            </div>
        </div>
    );
};

Alert.proptypes = {
    ...defaultAriaProps,
    title: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['primary', 'secondary', 'error', 'warning', 'success', 'info'])
};

Alert.defaultProps = {
    variant: 'success'
};

export default Alert;
